import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import {arrayObject} from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsUserUpdate } from "store/actions"
import validator from "email-validator"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import FormLabel from "@material-ui/core/FormLabel"
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Radio from "@material-ui/core/Radio";
// import Checkbox from "@material-ui/core/Checkbox";

// @material-ui/icons
import PersonAddIcon from "@material-ui/icons/PersonAdd"
import EditIcon from "@material-ui/icons/Edit"
import CloudUploadIcon from "@material-ui/icons/CloudUpload"
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite";
// import DeleteForeverIcons from "@material-ui/icons/DeleteForever";
// import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"
// import Switch from "@material-ui/core/Switch";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  }
}
class UserCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      _id:null,
      _idUserData:null,
      username: "",
      password: "",
      passwordConfirmed: "",
      userTypeID: 3,
      projectID: "0",

      firstName: "",
      lastName: "",
      // email: "",

      SelectListProject: [],
      SelectListUserType: this.props.listUserType,
      
      rowCurrentUserData:{},
    }
  }
  componentWillUpdate(nextProps, nextState) {
      if(nextProps.currentUserData && nextProps.currentUserData !== nextState.rowCurrentUserData){
        this.setState({
          rowCurrentUserData: nextProps.currentUserData,
          _id:nextProps.currentUserData._id,
          _idUserData:nextProps.currentUserData.user_data_id._id,
          username:nextProps.currentUserData.username, 
          projectID:nextProps.currentUserData.project_code,
          firstName:nextProps.currentUserData.user_data_id.first_name,
          lastName:nextProps.currentUserData.user_data_id.last_name,
          // email:nextProps.currentUserData.user_data_id.email,
        })
      }else if(nextProps.currentUserData === null && this.state._id !== null){
        this.setState({
          rowCurrentUserData: {},
          _id:null,
          _idUserData:null,
          username:"",
          userTypeID:3,
          projectID:0,
          firstName:"",
          lastName:"",
          // email:"",
        })
      }
  }
  componentDidMount() {
    // this.loadUserType(() => {
      this.loadProjectList(() => {
      })
    // })
  }

  loadProjectList(callback) {
    APIGet(UrlServer.URL_GET_PROJECT, ({datas}) => {
      const newConvertDatas = arrayObject(datas,[
        {
          oldKey:"code",
          newKey:"value"
        },
        {
          oldKey:"description",
          newKey:"name"
        }
      ]
      )
      this.setState({ SelectListProject: newConvertDatas }, () => {
        if (callback) callback()
      })
    })
  }
  // loadUserType(callback) {
  //   APIGet(UrlServer.URL_GET_USER_TYPE, ({datas}) => {
  //     const newConvertDatas = arrayObject(datas,[
  //       {
  //         oldKey:"code",
  //         newKey:"value"
  //       },
  //       {
  //         oldKey:"description",
  //         newKey:"name"
  //       }
  //     ]
  //     )
  //     this.setState({ SelectListUserType:newConvertDatas}, () => {
  //       if (callback) callback()
  //     })
  //   })
  // }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }
  handleSubmit = () => {
    if( this.state.username === ""){
      ErrorsCallback("ต้องการข้อมูล : ชื่อเข้าใช้งาน" )
    }else if( this.state.firstName === ""){
      ErrorsCallback("ต้องการข้อมูล : ชื่อ" )
    }else if( this.state.lastName === ""){
      ErrorsCallback("ต้องการข้อมูล : สกุล" )
    }
    // else if( this.state.email === ""){
    //   ErrorsCallback("ต้องการข้อมูล : อีเมล" )
    // }
    else{
      if (this.state.password !== this.state.passwordConfirmed) {
        ErrorsCallback("รหัสผ่านกับการยืนยันไม่ตรงกัน", null)
        return
      }
      // if (!validator.validate(this.state.email)) {
      //   ErrorsCallback("ผิดรูปแบบของอีเมล", null)
      //   return
      // }
      
      if(this.state._id){
        // แก้ไข =============
        const dataToSend = {
          _id:this.state._id,
          _idUserData:this.state._idUserData,
          username: this.state.username,
          password: this.state.password,
          userTypeCode: this.state.userTypeID,
          projectID: this.state.projectID,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          // email: this.state.email,
        }
    
        APIPost( UrlServer.URL_AUTH_USER_EDIT,dataToSend,(datas)=>{
          SuccessCallback(datas.message,null,()=>{
              // this.setState({
              //   _id:null,
              //   _idUserData:null,
              //   username: "",
              //   password:  "",
              //   passwordConfirmed:  "",
              //   userTypeID: 3,
              //   projectID: 0,
              //   firstName: "",
              //   lastName: "",
              //   email: "",
              //   rowCurrentUserData:{}
              // },()=>{
                this.props.callbackSetTabIndex(0,()=>{
                  var inv = setTimeout(() => {
                      clearInterval(inv)
                      this.props.callbackSetTabIndex(0,()=>{
                        this.props.listsUserUpdate()
                      },true)
                  }, 300);
                })
              // })
          })
        })
  
      }else{
        // สร้างใหม่ ==========
        const dataToSend = {
          username: this.state.username,
          password: this.state.password,
          userTypeCode: this.state.userTypeID,
          projectID: this.state.projectID,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          // email: this.state.email,
        }
    
        APIPost( UrlServer.URL_AUTH_CREATE,dataToSend,(datas)=>{
          this.setState({
            _id:null,
            _idUserData:null,
            username: "",
            password:  "",
            passwordConfirmed:  "",
            userTypeID: 3,
            projectID: 0,
            firstName: "",
            lastName: "",
            // email: "",
          },()=>{
            SuccessCallback(datas.message,null,()=>{
              
              this.props.callbackSetTabIndex(0,()=>{
                var inv = setTimeout(() => {
                    clearInterval(inv)
                    this.props.callbackSetTabIndex(0,()=>{
                      this.props.listsUserUpdate()
                    },true)
                }, 300);
              })

            })
          })
        })
      }
    }
    
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                {
                  ((this.state._id)?
                  <EditIcon />
                  :
                  <PersonAddIcon />
                  )
                }
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                {
                  ((this.state._id)?
                  "แก้ไขข้อมูลผู้ใช้งานระบบ ID:"+this.state._id
                  :
                  "ฟอร์มการสร้างรหัสผู้ใช้งานระบบ"
                  )
                }
                  
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ชื่อเข้าใช้งาน
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          disabled:((this.state._id)?true:false),
                          type: "text",
                          value: this.state.username,
                          placeholder: "User Name",
                          onChange: this.handleChangeState("username")
                        }}
                        helpText={((this.state._id)?"":(<span className="txt-c-r">* จำเป็นต้องใส่ </span>))}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        รหัสผ่าน
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "password",
                          value: this.state.password,
                          placeholder: "password",
                          onChange: this.handleChangeState("password")
                        }}
                        helpText={<span className="txt-c-r">* จำเป็นต้องใส่ {((this.state._id)?"ถ้าไม่เปลี่ยนรหัสผ่านไม่จำเป็นต้องใส่":"")}</span>}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ยืนยัน รหัสผ่าน
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "password",
                          value: this.state.passwordConfirmed,
                          placeholder: "Confirm password",
                          onChange: this.handleChangeState("passwordConfirmed")
                        }}
                        helpText={<span className="txt-c-r">* จำเป็นต้องใส่เหมือนรหัสผ่าน</span>}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ประเภทผู้ใช้งานระบบ
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      {
                        (this.state.SelectListUserType.length > 0) ?
                          <Select
                            value={this.state.userTypeID}
                            listData={this.state.SelectListUserType}
                            onChange={this.handleChangeState("userTypeID")}
                          />
                          : ""
                      }
                    </GridItem>
                  </GridContainer>
                  {/* <GridContainer>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        โปรเจค
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      {
                        (this.state.SelectListProject.length > 0) ?
                          <Select
                            value={this.state.projectID}
                            listData={this.state.SelectListProject}
                            onChange={this.handleChangeState("projectID")}
                          />
                          : ""
                      }
                    </GridItem>
                  </GridContainer> */}
                  <hr className={classes.marginHR} />
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ชื่อ
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.firstName,
                          placeholder: "Frist Name",
                          onChange: this.handleChangeState("firstName")
                        }}
                        helpText={<span className="txt-c-r">* จำเป็นต้องใส่</span>}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        สกุล
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.lastName,
                          placeholder: "Last Name",
                          onChange: this.handleChangeState("lastName")
                        }}
                        helpText={<span className="txt-c-r">* จำเป็นต้องใส่</span>}
                      />
                    </GridItem>
                  </GridContainer>
                  {/* <GridContainer>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        อีเมล
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "email",
                          value: this.state.email,
                          placeholder: "Email Format",
                          onChange: this.handleChangeState("email")
                        }}
                        helpText={<span className="txt-c-r">* จำเป็นต้องใส่</span>}
                      />
                    </GridItem>
                  </GridContainer> */}
                  {/* <GridContainer>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        Telephone No.
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "tel",
                          value: this.state.tel,
                          placeholder: "099-999-9999",
                          onChange: this.handleChangeState("tel")
                        }}
                        helpText={<span className="txt-c-r">* จำเป็นต้องใส่</span>}
                      />
                    </GridItem>
                  </GridContainer> */}
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={9} lg={10}>
                      <Button
                        color={(this.state._id)?"warning":"success"}
                        className={classes.mt4}
                        onClick={this.handleSubmit}
                      >
                        <CloudUploadIcon className={classes.icons} />
                        {(this.state._id)?"บันทึกการแก้ไข":"ลงทะเบียนผู้ใช้งานระบบ"}
                      </Button>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}
function mapStateToProps({ listsUser }) {
  return {
    listsUser: listsUser
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsUserUpdate }
  )
)(UserCreateAndEditManagement)
